import { Button, Icon, Stack } from '@ui-components/neo.tax';
import { ReactComponent as ChevronDownIcon } from '@ui-components/neo.tax/dist/icons/chevron-down.svg';
import { MenuButton, useMenuState } from 'ariakit';
import { ReactElement } from 'react';

import {
  ActionsMenu,
  ActionsMenuItem,
  ActionsMenuItemLabel,
  ActionsMenuItemText,
} from './asc-projects-actions-dropdown.styled';

type CreateProjectMenuButtonProps = {
  analyticId?: string;
  onCreateSingleProject: () => void;
  onUploadFromCsv: () => void;
};

export const CreateProjectMenuButton = ({
  analyticId,
  onCreateSingleProject,
  onUploadFromCsv,
}: CreateProjectMenuButtonProps): ReactElement => {
  const menuState = useMenuState({ gutter: 6, placement: 'bottom-end' });

  return (
    <>
      <Button id={analyticId} as={MenuButton} state={menuState} size="base" variant="primary" rounded="regular">
        <Stack direction="row" alignItems="center" gap={2}>
          <span>Create Project</span>
          <Icon size={2} node={<ChevronDownIcon />} />
        </Stack>
      </Button>
      <ActionsMenu state={menuState} portal aria-label="Create project options">
        <ActionsMenuItem
          onClick={(): void => {
            menuState.hide();
            onCreateSingleProject();
          }}
        >
          <ActionsMenuItemText>
            <ActionsMenuItemLabel>Create one project</ActionsMenuItemLabel>
          </ActionsMenuItemText>
        </ActionsMenuItem>
        <ActionsMenuItem
          onClick={(): void => {
            menuState.hide();
            onUploadFromCsv();
          }}
        >
          <ActionsMenuItemText>
            <ActionsMenuItemLabel>Upload from CSV</ActionsMenuItemLabel>
          </ActionsMenuItemText>
        </ActionsMenuItem>
      </ActionsMenu>
    </>
  );
};
